import React from 'react';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-middle">
                    <div className="footer-text">
                        <p className="footer-company-name">Prestige Clean</p>
                        <p>Phone: <a href="tel:5064716129">(506) 471-6129</a></p>
                        <p>Email: <a href="mailto:prestigecleanwindows@gmail.com">prestigecleanwindows@gmail.com</a></p>
                        <div className="social-links">
                            <a href="https://www.instagram.com/prestigecleanwindows/" target="_blank" rel="noopener noreferrer">
                                <FaInstagram className="social-icon" />
                            </a>
                            <a href="https://www.facebook.com/people/Prestige-Clean/100092660852751/" target="_blank" rel="noopener noreferrer">
                                <FaFacebook className="social-icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {currentYear} Prestige Clean. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
